import { MainLogin } from 'pages/Login/Login';
import { ResetPassword } from 'pages/Login/ResetPassword';
import { UnsupportedBrowser } from 'pages/Login/UnsupportedBrowserScreen';
import { isIE } from 'react-device-detect';
import { Route, Switch } from 'react-router-dom';

/**
 * Login routes for all of the pages under "/login" URL. Not used during main app function.
 */
export function LoginRoutes() {
    if (isIE) {
        return <UnsupportedBrowser />;
    }

    return (
        <Switch>
            <Route exact path="/login/reset" component={ResetPassword} />
            <Route path="/login" component={MainLogin} />
            <Route path="/" component={MainLogin} />
        </Switch>
    );
}
